// import { images } from "@constants";
import { Button, Form, Input, Typography } from "antd";
import { FormLoginWrapper, LoginPageWrapper } from "./LoginPageStyled";
import { LOGIN_CONSTANT } from "./constant";
import useLoginPage from "./hooks/useLoginPage";

const { LABEL, NAME, TITLE, PLACEHOLDER, LOGO, VERSION } = LOGIN_CONSTANT;
const { Title } = Typography;

const FIELDS_CONFIG = {
  ID: {
    required: false,
    label: LABEL.ID,
    name: NAME.USERNAME,
  },
  PASSWORD: {
    required: false,
    label: LABEL.PASSWORD,
    name: NAME.PASSWORD,
  },
};

function LoginPage() {
  const { state, handler } = useLoginPage();

  return (
    <LoginPageWrapper>
      <div>
        <div className="background-overlay">
          <div className="background-form" />
        </div>
      </div>
      <FormLoginWrapper changeheight={state.messageError}>
        <div className="logo-form">
          {/* <img src={images.logoForm} alt="logo-form" /> */}
          <h1>{LOGO}</h1>
        </div>

        <Form
          name="login"
          onFinish={handler.handleSubmitFormSuccess}
          onFinishFailed={handler.handleSubmitFormFail}
          layout="vertical"
          className="login-form"
          form={state.form}
        >
          <div className="login-form_title">
            <Title level={3}>{TITLE.LOGIN}</Title>
            <p>{TITLE.DESCRIPTION}</p>
          </div>
          <Form.Item
            {...FIELDS_CONFIG.ID}
            style={{ marginBottom: 16 }}
            className="id-input"
            validateStatus={state.isAuthError ? "error" : ""}
            help={null}
          >
            <Input
              ref={state.idRef}
              tabIndex={0}
              allowClear
              size="large"
              autoComplete="off"
              placeholder={PLACEHOLDER.INPUT}
            />
          </Form.Item>
          <Form.Item
            {...FIELDS_CONFIG.PASSWORD}
            style={{ marginBottom: state.messageError ? "16px" : "24px" }}
            validateStatus={state.isAuthError ? "error" : ""}
            help={null}
          >
            <Input.Password
              size="large"
              autoComplete="off"
              placeholder={PLACEHOLDER.INPUT}
            />
          </Form.Item>

          {state.messageError && (
            <p className="logo-form_message-error">{state.messageError}</p>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={state.isLoading}
              className="login-form_button"
              disabled={!state.idWatch?.trim() || !state.passwordWatch}
            >
              {TITLE.LOGIN}
            </Button>
          </Form.Item>

          <div className="ver-build">{VERSION}</div>
        </Form>
      </FormLoginWrapper>
    </LoginPageWrapper>
  );
}
export { LoginPage };
